import { AppLayout, ContentLayout } from '@amzn/awsui-components-core';
import Spinner from '@amzn/awsui-components-core/spinner';
import React from 'react';
import { Navigate, useParams, useSearchParams } from 'react-router-dom';
import { LoadingStatus } from 'src/components/context/AppContextModels';
import { useAppContext } from 'src/components/context/AppContextProvider';
import { EmbedApp } from 'src/components/das-finsuite/embedded-apps/EmbedApp';
import { EmptyState } from 'src/components/generic-components/empty-state';

export const EmbedAppPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [searchParams] = useSearchParams();
  const resetKey = searchParams.get('t') || '';
  const { listOfApplications, contextLoadingStatus } = useAppContext();

  if (contextLoadingStatus !== LoadingStatus.Completed) {
    return <Spinner size="large" />;
  }

  const application = listOfApplications.find((app) => app.id === id);

  if (!application) {
    return <EmptyState title="Application Not Found" description="The application you are looking for does not exist." verticalCenter={true} />;
  }

  if (!application.embeddingEnabled) {
    return <Navigate to="/all-apps" replace />;
  }

  return (
    <AppLayout
      headerSelector="#h"
      contentType="dashboard"
      disableContentPaddings
      navigationHide
      toolsHide
      maxContentWidth={Number.MAX_VALUE}
      content={
        <ContentLayout disableOverlap>
          <EmbedApp key={`${id}-${resetKey}`} application={application} />
        </ContentLayout>
      }
    />
  );
};
